
import { computed, defineComponent, ref } from 'vue'
import { ColorEnum } from '../../enums/color.enum'
import CopyToClipboard from './copy-to-clipboard.component.vue'
import { EpbBadge } from './epb-badge'
import { EpbInputHelp } from './epb-input-help'

export default defineComponent({
  name: 'EpbEditableInputLayout',
  components: {
    CopyToClipboard,
    EpbBadge,
    EpbInputHelp,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    copyToClipboard: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const baseClass = 'epb-editable-input-layout'

    const hovered = ref(false)

    const canShowHoveredBadge = computed(() => hovered.value && !props.isFocused)

    const showEditBadge = computed(
      () => canShowHoveredBadge.value && !props.copyToClipboard && !props.disabled,
    )

    const showCopyBadge = computed(
      () => canShowHoveredBadge.value && props.copyToClipboard && props.value,
    )

    return {
      baseClass,
      hovered,
      ColorEnum,
      showEditBadge,
      showCopyBadge,
    }
  },
})
